import React from "react"

import LanguageSelector from "./LanguageSelector"
import CompanyMotto from "./CompanyMotto"
import Navigation from "./Navigation"
import PageContent from "./PageContent"


class App extends React.Component {
    constructor(props) {
        super(props);
        this.logisticsRef = React.createRef();
        this.transportRef = React.createRef();
        this.warehousingRef = React.createRef();
        this.contactsRef = React.createRef();
    }

    render() {
        return (
            <div className="app-wrapper">
                <div className="header-container">
                    <LanguageSelector language={this.props.languageSelection}></LanguageSelector>
                </div>
                <CompanyMotto></CompanyMotto>
                <Navigation sectionRefs={{
                    logisticsRef: this.logisticsRef,
                    transportRef: this.transportRef,
                    warehousingRef: this.warehousingRef,
                    contactsRef: this.contactsRef
                }}></Navigation>
                <PageContent sectionRefs={{
                    logisticsRef: this.logisticsRef,
                    transportRef: this.transportRef,
                    warehousingRef: this.warehousingRef,
                    contactsRef: this.contactsRef
                }} recommendations={this.props.recommendations} companydocuments={this.props.companydocuments}></PageContent>
            </div>

        );
    }
}

export default App;